module.exports = __webpack_public_path__ + "static/media/IMG9.7659a5fd.png";